/** @format */

import { Injectable } from "@angular/core";
import { ToastService } from "mis-crystal-design-system/toast";
import { parseZone } from "moment";
import { BehaviorSubject, combineLatest, Observable, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ModalService } from "mis-design-system/mis-modal";
import { NsWISConfigurations } from "../models/configurations.model";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";
import { ApiService } from "./api.service";
import { VaccinationEligibilityComponent } from "../components/modals/vaccination-eligibility/vaccination-eligibility.component";
import { ConfigurationService } from "./configuration.service";
import { BookingDataService } from "./booking-data.service";
import { LoaderService } from "./loader.service";

@Injectable({
  providedIn: "root"
})
export class HomeDataService {
  constructor(
    private apiSvc: ApiService,
    private toasts: ToastService,
    private modalSvc: ModalService,
    private configSvc: ConfigurationService,
    private bookingSvc: BookingDataService,
    private loader: LoaderService
  ) {}
  private configSubject$: BehaviorSubject<NsWISConfigurations.IConfigurations> = new BehaviorSubject(null);
  configSubject = this.configSubject$.asObservable();
  private actionStream$: Subject<"OFFICE" | "WFH"> = new Subject();
  actionStream = this.actionStream$.asObservable();

  employeeInfo: Observable<NsEmpWebExpData.IEmployee>;

  refreshReplayStreams(): void {
    this.employeeInfo = this.apiSvc.genReplayStream(this.apiSvc.getEmpProfile(this.apiSvc.genEmpInfoQuery())).pipe(
      map(res => {
        if (!res?.dataPresent || res?.data?.getEmployee?.length <= 0) {
          this.toasts.displayMsg("Failed to load user info");
          return;
        }
        return res?.data?.getEmployee?.[0];
      })
    );
  }

  configSubjectData(data: NsWISConfigurations.IConfigurations): void {
    this.configSubject$.next(data);
  }

  publishAction(id: "OFFICE" | "WFH") {
    this.actionStream$.next(id);
  }

  quickActionEvent(id: string, callback: (res: boolean) => void): void {
    if (id === "OFFICE") {
      this.loader.show();
      combineLatest([this.apiSvc.getEligibility(), this.apiSvc.getVaxStatus()])
        .pipe(
          catchError(err => {
            this.loader.hide();
            this.toasts.displayMsg("Unable to get eligibility. Please try again later...");
            return [];
          })
        )
        .subscribe(
          ([eligibility, status]) => {
            this.loader.hide();
            if (!eligibility?.eligible && eligibility?.ineligibilityReason) {
              if (eligibility.popupType === "VAX") {
                this.modalSvc.show(
                  VaccinationEligibilityComponent,
                  { eligibility, status },
                  {
                    closeOnBackdropClick: true,
                    ...(!this.configSvc.isMobile && { width: "580px" })
                  }
                );
              } else {
                this.toasts.displayMsg(eligibility?.ineligibilityReason, 4000);
              }
              callback(false);
              return;
            }
            if (
              eligibility?.expiryTime &&
              parseZone(eligibility?.expiryTime).tz(this.bookingSvc.timezone).isSameOrAfter(parseZone().tz(this.bookingSvc.timezone))
            ) {
              this.bookingSvc.wfoExpiryTime = parseZone(eligibility?.expiryTime).tz(this.bookingSvc.timezone);
            }
            callback(true);
          },
          __ => {
            console.log("some error occured");
          }
        );
    } else {
      callback(true);
    }
  }
}
